import {FC} from 'react';

import {preparedRateT} from '../providers/createRateSheetProvider';

interface FormRowComponentProps {
  onDelete: () => void;
  rate: preparedRateT & {error?: boolean; errorMessage?: string};
  onUpdateRate: (data: preparedRateT) => void;
}

const RateSheetFormRowComponent: FC<FormRowComponentProps> = ({onDelete, rate, onUpdateRate}) => {
  const handleRateChange = (field: keyof preparedRateT, value: string) => {
    let parsedValue: number | null = 0;

    if (field === 'min_quantity') {
      parsedValue = parseInt(value) || 0;
    } else {
      parsedValue = parseFloat(value) || 0;
    }

    onUpdateRate({
      ...rate,
      [field]: parsedValue,
    });
  };

  return (
    <>
      {rate.error && (
        <tr>
          <td colSpan={10}>
            <div className="alert alert-danger" role="alert">
              {rate.errorMessage}
            </div>
          </td>
        </tr>
      )}
      <tr className="border border-defaultborder dark:border-defaultborder/10">
        <td className={`flex items-center gap-2 ${rate.Product?.product_image_url ? 'min-w-[150px]' : ''}`}>
          {/* logo if one */}
          {rate.Product?.product_image_url && (
            <img src={rate.Product?.product_image_url} alt="product" className="h-10 w-10 rounded-sm" />
          )}
          <span>{rate.Product?.product_name}</span>
        </td>
        <td>
          <span>{rate.Brand?.brand_name}</span>
        </td>
        <td>
          <span>{rate.Product?.product_category}</span>
        </td>
        <td>
          <span>{rate.Product?.product_subcategory}</span>
        </td>
        {/* Wholesale Price */}
        <td>
          <input
            type="number"
            className="form-control w-full min-w-[100px]"
            value={rate.wholesale_price}
            onChange={e => handleRateChange('wholesale_price', e.target.value)}
            min={0}
            step={0.01}
          />
        </td>
        {/* TNC Price */}
        <td>
          <input
            type="number"
            className="form-control w-full min-w-[100px]"
            value={rate.tnc_price}
            onChange={e => handleRateChange('tnc_price', e.target.value)}
            min={0}
            step={0.01}
          />
        </td>
        {/* MIN QUANTITY */}
        <td>
          <input
            type="number"
            className="form-control w-full min-w-[100px]"
            value={rate.min_quantity}
            onChange={e => handleRateChange('min_quantity', e.target.value)}
            min={0}
            step={1}
          />
        </td>
        {/* FACTORED PRICE */}
        <td className="w-full">
          <div className="relative flex min-w-[150px] items-center gap-2">
            <input
              type="number"
              className="form-control w-4/5"
              value={rate.factored_price ?? ''}
              onChange={e => handleRateChange('factored_price', e.target.value)}
              min={0}
              step={0.01}
            />
            <span className="absolute -bottom-3 left-0 text-xs text-gray-500">
              suggested: {rate.Product?.product_factored_price || 'N/A'}
            </span>
            {/* clear icon */}
            <button
              aria-label="clear"
              type="button"
              className="ti-btn ti-btn-sm ti-btn-icon ti-btn-danger w-1/5"
              onClick={() => onUpdateRate({...rate, factored_price: 0})}
            >
              <i className="ri-close-circle-line"></i>
            </button>
          </div>
        </td>
        {/* MSRP */}
        <td className="w-full">
          <div className="flex min-w-[150px] items-center gap-2">
            <input
              type="number"
              className="form-control w-4/5"
              value={rate.msrp ?? ''}
              onChange={e => handleRateChange('msrp', e.target.value)}
              min={0}
              step={0.01}
            />
            {/* clear icon */}
            <button
              aria-label="clear"
              type="button"
              className="ti-btn ti-btn-sm ti-btn-icon ti-btn-danger w-1/5"
              onClick={() => onUpdateRate({...rate, msrp: null})}
            >
              <i className="ri-close-circle-line"></i>
            </button>
          </div>
        </td>

        {/* Delete */}
        <td>
          <button
            aria-label="delete"
            type="button"
            className="ti-btn ti-btn-sm ti-btn-icon ti-btn-danger"
            onClick={onDelete}
          >
            <i className="ri-delete-bin-5-line"></i>
          </button>
        </td>
      </tr>
    </>
  );
};

export default RateSheetFormRowComponent;
